export const NAV_BUTTONS: { name: string; route: string }[] = [
    { name: 'For Creators', route: 'creators' },
    { name: 'For Brands', route: 'brands' },
    { name: 'Our Purpose', route: 'purpose' },
    { name: `Let's Connect`, route: 'connect' },
];

export const LOGIN_OR_SIGN_UP = 'Login or Sign up'